import React from 'react';
import './Heroworks.css'
import Eth from './assets/eth.png'
import Btc from './assets/btc.png'
import Bworld from './assets/bworld.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTrendUp } from '@fortawesome/free-solid-svg-icons';

const Heroworks = () => {
    return(
        <div className="heroworks">
            <div className="how-it">
                <h1> How It Work's</h1>
                <p>You'll Look a little lovelier each day with fabulous pink cryptocurrency.<br></br>I wouldn't leave the house without cryptocurrency. Cryptocurrency is <br></br> rolling, The others are stoned.</p>
            </div>
            <div className='crypto'>
                <div className='eth'>
                    <img src={Eth} alt='eth' />
                    <h3>Ethereum</h3>
                    <p>Ethereum is a decentralized blockchain platform enabling smart contracts, <br></br> decentralized applications ,and <br></br>cryptocurrency transactions.</p>
                    <span className="ethbtn"><a href="#started">Let's Get Started &nbsp;<FontAwesomeIcon icon={faArrowTrendUp} /> </a></span>
                </div>
                <div className='btc'>
                    <img src={Btc} alt='btc' />
                    <h3>Bitcoin</h3>
                    <p>Bitcoin is a decentralized digital currency enabling peer-to-peer transactions,<br></br> blockchain tech, and secure,<br></br> transparent transfers.</p>
                    <span className="btcbtn"><a href="#started">Let's Get Started &nbsp;<FontAwesomeIcon icon={faArrowTrendUp} /> </a></span>
                </div>
                <div className='bworld'>
                    <img src={Bworld} alt='bworld' />
                    <h3>Bitcoin World</h3>
                    <p>Bitcoin world is a decentralized digital economy powered by blockchain  <br></br>tech, enabling peer-to-peer <br></br> transactions.</p>
                    <span className="bworldbtn"><a href="#started">Let's Get Started &nbsp;<FontAwesomeIcon icon={faArrowTrendUp} /> </a></span>
                </div>
            </div>
        </div>
    )
     
}

export default Heroworks;